import { render, staticRenderFns } from "./joinConfirmModal.vue?vue&type=template&id=6a58a410&scoped=true&lang=pug"
import script from "./joinConfirmModal.vue?vue&type=script&lang=js"
export * from "./joinConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./joinConfirmModal.vue?vue&type=style&index=0&id=6a58a410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58a410",
  null
  
)

export default component.exports